import {useMutation} from "react-query";
import {AddRoleMemberCommand} from "../../models/user";
import roleMemberService from "../../services/RoleMemberService";

export default function useAddRoleMember() {
   return useMutation((request: AddRoleMemberCommand) => roleMemberService.add(request));
}